var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pt-4",attrs:{"light":"","color":"primary"}},[_c('chart',{attrs:{"height":"300","options":_vm.optionsTensao,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }